/**
 * @generated SignedSource<<0d5c7610cac057d85808f320adc98b8e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AssociationType = "MANDATORY" | "OPTIONAL";
import { FragmentRefs } from "relay-runtime";
export type IcdDiagnosisFragment$data = {
  readonly associationType: AssociationType | null;
  readonly diagnosisCode: string;
  readonly id: string;
  readonly isAssociation: boolean;
  readonly linkedConditionIcdDiagnosis: {
    readonly diagnosisCode: string;
    readonly text: string;
  } | null;
  readonly primaryCode: string | null;
  readonly secondaryCode: string | null;
  readonly text: string;
  readonly " $fragmentType": "IcdDiagnosisFragment";
};
export type IcdDiagnosisFragment$key = {
  readonly " $data"?: IcdDiagnosisFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"IcdDiagnosisFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "diagnosisCode",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IcdDiagnosisFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAssociation",
      "storageKey": null
    },
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondaryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "associationType",
      "storageKey": null
    },
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "IcdDiagnosis",
      "kind": "LinkedField",
      "name": "linkedConditionIcdDiagnosis",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        (v1/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "IcdDiagnosis",
  "abstractKey": null
};
})();

(node as any).hash = "72b6989470d93877acef21544ddcdf38";

export default node;
